import { styled } from '@mui/material/styles';
import { EDTypography, info } from "@trailblazer-game/ed-webkit";
import Stack from "@mui/material/Stack";
import React from "react";

interface ILogMessageProps {
    logMessage?: { message: string | React.ReactNode, icon?: React.ReactNode, color?: string } | undefined;
    children?: React.ReactNode | React.ReactNode[];
}

export function LogMessage(props: ILogMessageProps) {
    return (
        <EDTypography variant={"caption"}
                      sx={{ color: props.logMessage?.color || info('main') }}>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"flex-start"} spacing={1}>
                {props.logMessage?.icon}
                {props.logMessage && <b dangerouslySetInnerHTML={{__html: `${props.logMessage!.message}`}}></b>}
                {props.children}
            </Stack>
        </EDTypography>
    )
}

// Default style!
const LogMessageStyled = styled(LogMessage)({});

// Export
export default LogMessageStyled;